import { StepHandlerContextProvider, StepHandlerContextType as StepHandlerContextType } from ".";
import { ErrorBoundary2 } from "@/pages/ErrorBoundary2";

type StepHandlerProviderProps = {
    children: React.ReactNode
    value: StepHandlerContextType;
};
export function StepHandlerProvider({ value, children }: StepHandlerProviderProps) {
    return (
        <StepHandlerContextProvider value={value}>
            <ErrorBoundary2 msg="StepHandler Inner">
                {children}
            </ErrorBoundary2>
        </StepHandlerContextProvider>
    );
}